module.exports = __webpack_public_path__ + "img/ups.jpg.67c19bc3.webp";